const englishPack = {
	"lb_app_logo_header":"Transform your product line into an online store or website in minutes!",
	"lb_app_logo_slider1_caption":"Apparel",
	"lb_app_logo_slider2_caption":"Accessories",
	"lb_app_logo_slider3_caption":"Footwear",
	"lb_app_logo_slider4_caption":"Jewellery",
	"lb_app_logo_slider5_caption":"Furnishings"
};

const hindiPack = {
	"lb_app_logo_header":"एक ऑनलाइन स्टोर या मिनटों में वेबसाइट में अपने उत्पाद लाइन को बदलने!",
	"lb_app_logo_slider1_caption":"परिधान",
	"lb_app_logo_slider2_caption":"सामान",
	"lb_app_logo_slider3_caption":"जूते",
	"lb_app_logo_slider4_caption":"आभूषण",
	"lb_app_logo_slider5_caption":"असबाब"
};

const languagePackRepository = {"en" : englishPack, "hi" : hindiPack};

export const languagePack = (lang) => {
	return languagePackRepository[lang];
}